// extracted by mini-css-extract-plugin
export default {"page":"DealerEdit_page__2kr1a","createBtn":"DealerEdit_createBtn__2r0ZP","tabs":"DealerEdit_tabs__M3zj9"};